import React from 'react'

function FlipIcon({color = 'currentColor'}) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path
        d="M12.33 15.932a1.624 1.624 0 00.366-1.804 1.664 1.664 0 00-.621-.744 1.714 1.714 0 00-.939-.279H8.602v-7.45C8.602 4.742 7.846 4 6.912 4c-.932 0-1.689.741-1.689 1.656v7.45H2.69c-.334 0-.66.097-.938.278-.278.182-.495.441-.622.743a1.625 1.625 0 00.366 1.805l4.223 4.139c.66.646 1.73.646 2.39 0l4.223-4.14zM11.495 8.624a1.645 1.645 0 00-.462.848c-.066.32-.032.654.096.956.128.303.344.561.622.743.278.182.604.28.938.28h2.534V18.9c0 .914.757 1.656 1.69 1.656.933 0 1.689-.742 1.689-1.656v-7.45h2.534c.334 0 .66-.097.939-.279.277-.182.494-.44.622-.743a1.624 1.624 0 00-.366-1.804l-4.224-4.14a1.714 1.714 0 00-2.389 0l-4.223 4.14z"
        fill={color}
      />
    </svg>
  )
}

function WarnIcon({color = 'currentColor', w, h}) {
  return (
    <svg
      width={w}
      height={h}
      fill="none"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      viewBox="0 0 24 24"
    >
      <path d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
  )
}

function CompressIcon({color = 'currentColor'}) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <g clipPath="url(#clip0)">
        <path
          d="M22.91 10.35H18V8.749c0-.432-.266-.82-.674-.986a1.113 1.113 0 00-1.188.231l-2.728 2.668a1.05 1.05 0 000 1.51l2.728 2.667c.152.15.347.252.558.293.212.04.431.02.63-.061.2-.08.37-.218.49-.393a1.05 1.05 0 00.184-.593v-1.6h4.91A1.08 1.08 0 0024 11.416a1.08 1.08 0 00-1.09-1.067zM7.861 7.994a1.113 1.113 0 00-1.189-.231c-.199.08-.37.218-.49.393A1.05 1.05 0 006 8.75v1.6H1.09A1.08 1.08 0 000 11.418c0 .59.488 1.067 1.09 1.067H6v1.6c0 .212.064.418.184.594.12.175.29.312.49.393a1.113 1.113 0 001.188-.232l2.728-2.667a1.05 1.05 0 000-1.51L7.862 7.994z"
          fill="#FBFBFB"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <path fill={color} d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}

export {FlipIcon, WarnIcon, CompressIcon}
